var _defs, _polygon, _polyline, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a2834;}.cls-2{fill:#594a55;}.cls-3{fill:#33222e;}.cls-4{fill:aqua;}.cls-5{fill:#4c3547;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.33 301.29 53.48 275.15 646.09 315.44 693.23 425.71 13.41 426.12 32.33 301.29"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "32.33 301.29 53.58 272.1 577.25 259.44 646.09 315.44"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "17.4 434.04 686.54 434.04 693.23 425.71 13.19 425.71 17.4 434.04"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "24.77 447.2 676.4 447.2 686.19 434.44 17.85 434.44 24.77 447.2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "506.97 425.7 693.45 426.12 646.31 315.84 173.62 303.74 506.97 425.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipTram);
export default __webpack_public_path__ + "static/media/bg-ship-tram.df48773e51adb33275bf8b3cc3167d64.svg";
export { ForwardRef as ReactComponent };